import util from '@bmp-vue/core/api/util'
import carroceria from './carroceria'
const controller = 'PagolVeiculos'
const ctrl = Object.assign({}, util.GetCrud(controller, ['none']), {
  Get (th) {
    return th.$param.TaxasAutoatendimento
  },
  GetPrazo (th) {
    const list = ctrl.Get(th).filter(objeto => objeto.DtFabricacao.includes(th.model.PropostaDadosVeiculo.AnoFab))
    return [...new Set(list.map(obj => obj.prazo))].reverse()
  },
  GetTaxa (th) {
    const listPorPrazo = ctrl.Get(th).filter(objeto => objeto.DtFabricacao.includes(th.model.PropostaDadosVeiculo.AnoFab)).filter(obj => obj.prazo === th.model.Prazo)
    const porcentagem = (th.model.VlrEntrada / th.model.VlrProdutoBem) * 100;
    if (listPorPrazo.find((item) => item.entrada === Math.round(porcentagem / 5) * 5)) {
      return listPorPrazo.find((item) => item.entrada === Math.round(porcentagem / 5) * 5)
    } else if ((listPorPrazo.find((item) => item.entrada === Math.round(porcentagem / 10) * 10))) {
      return listPorPrazo.find((item) => item.entrada === Math.round(porcentagem / 10) * 10)
    } else {
      return listPorPrazo.at(-1)
    }
  },
  GetEntrada (th) {
    return ctrl.Get(th).filter(objeto => objeto.DtFabricacao.includes(th.model.PropostaDadosVeiculo.AnoFab))[0].entrada
  },
  AnoFabricacao: [
    { text: '2024', value: 2024 },
    { text: '2023', value: 2023 },
    { text: '2022', value: 2022 },
    { text: '2021', value: 2021 },
    { text: '2020', value: 2020 },
    { text: '2019', value: 2019 },
    { text: '2018', value: 2018 },
    { text: '2017', value: 2017 },
    { text: '2016', value: 2016 },
    { text: '2015', value: 2015 },
    { text: '2014', value: 2014 },
    { text: '2013', value: 2013 },
    { text: '2012', value: 2012 },
    { text: '2011', value: 2011 },
    { text: '2010', value: 2010 },
    { text: '2009', value: 2009 },
    { text: '2008', value: 2008 }
  ],
  GetItem (modeloAno, tipoParcela) {
    var retorno = ctrl.Get.find(item => item.tipoParcela === tipoParcela && item.modeloAno.some(p => p === modeloAno))
    if (!retorno) {
      retorno = ctrl.Get.find(item => item.tipoParcela === tipoParcela && ((item.modeloAno[0] === 2000 && item.modeloAno[0] >= modeloAno) || (item.modeloAno[0] === 2016 && item.modeloAno[0] <= modeloAno)))
    }
    return retorno
  },
  GetTaxaVeiculo (th) {
    var taxa = 0
    const tx = ctrl.GetItem(th.model.PropostaDadosVeiculo.AnoMod, th.model.Parcelas)
    if (tx) {
      taxa = tx.taxa
    }
    th.$set(th.model, 'PercJurosMensal', taxa)
  },
  Carroceria: carroceria,
  SavePropostaCampoAuxiliar (th) {
    const campos = []
    if ([null, undefined].indexOf(th.model.PropostaDadosVeiculo.ZeroKM) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTAVEICULO_ZEROKM', ValorCampo: th.model.PropostaDadosVeiculo.ZeroKM }) }
    if ([null, undefined].indexOf(th.model.AdicionalObservacao) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_OBSERVACOES', ValorCampo: th.model.AdicionalObservacao }) }
    if ([null, undefined].indexOf(th.model.AdicionalContrato) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_CONTRATO', ValorCampo: th.model.AdicionalContrato }) }
    if ([null, undefined].indexOf(th.model.AdicionalEstacionamento) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_ESTACIONAMENTO', ValorCampo: th.model.AdicionalEstacionamento }) }
    if ([null, undefined].indexOf(th.model.PropostaDadosVeiculo.Carroceria) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_CARROCERIA', ValorCampo: th.model.PropostaDadosVeiculo.Carroceria }) }

    if (campos.length > 0) { th.$api.Multiplo.Post('SavePropostaCampoAuxiliar', { dto: campos }) }
  },
  ImportaAssinante (th, request, importEmitente) {
    if (importEmitente) {
      th.$api.Multiplo.Post('InsertCCBDigitalAssinatura', request).then(function (response) {
        th.$api.UI.PostAction(response, 'Importação realizada com sucesso!')
      })
    }
  },
  ColorSituacao: [
    {
      value: 0,
      color: '#1976D2'
    },
    {
      value: 1,
      color: '#FA00F0'
    },
    {
      value: 2,
      color: '#00C2FF'
    },
    {
      value: 3,
      color: '#FF0000'
    },
    {
      value: 4,
      color: '#FF0000'
    },
    {
      value: 5,
      color: '#FA9600'
    },
    {
      value: 6,
      color: '#4200FF'
    },
    {
      value: 7,
      color: '#02D917'
    },
    {
      value: 8,
      color: '#02D917'
    },
    {
      value: 9,
      color: '#02D917'
    },
    {
      value: 10,
      color: '#02D917'
    },
    {
      value: 11,
      color: '#FA9600'
    }
  ],
  TipoPlaca: [
    { text: 'Carros e Utilitários', value: 1 },
    { text: 'Caminhões e Micro-Ônibus', value: 3 },
    { text: 'Ônibus', value: 2 }
  ],
  MascaraRG (valor) {
    const numFormatado = valor.toString().padStart(9, '0');
    return numFormatado.replace(/(\d{2})(\d{3})(\d{3})(\d{1})/, '$1.$2.$3-$4')
  },
  MotivoRejeicao: [
    { text: 'MENOR DE 18 ANOS', value: 1 },
    { text: 'MAIS DE 70 ANOS', value: 2 },
    { text: 'CEP DE RISCO', value: 3 },
    { text: 'NEGADO POLÍTICA DE CRÉDITO', value: 200 },
    { text: 'CHECAGEM INTERNA DESFAVORÁVEL', value: 201 },
    { text: 'NEGADO ANÁLISE INTERNA', value: 202 }
  ],
  ChangeVlrProdutoBem (th, value) {
    let vlrEntrada = 0
    if (value) {
      value = th.$api.UI.Parse.Decimal(value)
      vlrEntrada = parseFloat((value * th.$param.VlrMinEntrada).toFixed(2))
    }
    th.$set(th.model, 'VlrEntrada', vlrEntrada)
  },
  TipoErroGravameEnum: {
    Externo: 1,
    Interno: 2
  },
})

export default ctrl
